<div class="relative h-full overflow-y-auto">
  <!-- Loading Overlay -->
  @if (isLoading) {
    <div class="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div class="flex flex-col items-center gap-4">
        <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary"></div>
        <p class="text-gray-600">Loading accessibility...</p>
      </div>
    </div>
  }

  <!-- Widget Container -->
  <div class="h-full" #widgetContainer id="angular-widget-container"></div>
</div>
